import styled from "styled-components";

export const ServicesSection = styled.section`
  width: 100%;
  background: linear-gradient(to bottom, #c7c4f7 0%, #f5f5fc 50%, #ffffff 100%);
  font-family: Raleway, sans-serif;
  color: #1a1633;
  display: flex;
  flex-direction: column;
  align-items: center;


  @media (max-width: 768px) {
    padding: 70px 0;
  }
`;
export const ServicesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 5vw; /* espace proportionnel à la largeur de l'écran */
  width: 100%;

  @media (min-width: 1600px) {
    grid-template-columns: repeat(2, 1fr); /* 2 colonnes pour tous les écrans */
    gap: 4vw;
  }

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 6vw;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 8vw;
  }
`;
export const ServicesContainer = styled.div`
  margin: 0 auto;        /* centrer horizontalement */
  padding: 4vw 6vw;        /* marges internes flexibles */

  @media (min-width: 1600px) {
    padding: 2.76vw 5.448vw;
    
  }

  @media (max-width: 1024px) {
    width: 95vw;
    padding: 0 5vw;
  }

  @media (max-width: 768px) {
    width: 96vw;
    padding: 0 4vw;
  }

  @media (max-width: 480px) {
    width: 98vw;
    padding: 0 3vw;
  }
`;



export const ServicesHeader = styled.div`
  text-align: center;
  margin-bottom: 80px;
`;

export const TitleTag = styled.h3`
  color: #7874a0;
  font-size: 1.9rem;
  font-weight: 200;
  margin-bottom: 10px;
`;

export const Title = styled.h2`
  font-size: 2.8rem;
  font-weight: 200;
  color: #221c46;

  @media (max-width: 768px) {
    font-size: 2.2rem;
  }
`;

export const Description = styled.p`
  margin-top: 20px;
  font-weight: 200;
  font-size: 1.15rem;
  color: #2b254e;
  max-width: 720px;
  margin-left: auto;
  margin-right: auto;
  line-height: 1.7;
`;

export const ServiceItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 25px;
  border-bottom: 1px solid #b3b1d1;
  padding-bottom: 35px;
  text-align: left;

  @media (max-width: 768px) {
    gap: 18px;
    padding-bottom: 25px;
  }
`;

export const IconBox = styled.div`
  width: 55px;
  height: 55px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ServiceText = styled.div`
  flex: 1;
`;

export const ServiceTitle = styled.h4`
  margin: 0 0 10px;
  font-size: 1.3rem;
  font-weight: 200;
  color: #1a1633;

  @media (max-width: 768px) {
    font-size: 1.15rem;
  }
`;

export const ServiceDescription = styled.p`
  font-size: 1rem;
  color: #504d6b;
  line-height: 1.65;
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: transparent;
`;

export const ScrollDownContainer = styled.div`
  margin-top: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ScrollDown = styled.div`
  font-size: 22px;
  color: #1a1633;
  animation: bounce 1.8s infinite;

  &.second-arrow {
    margin-top: -15px;
    animation: bounce 1.8s infinite 0.3s;
  }

  @keyframes bounce {
    0%, 20%, 50%, 80%, 100% {
      transform: translateY(0);
    }
    40% {
      transform: translateY(-10px);
    }
    60% {
      transform: translateY(-5px);
    }
  }
`;
